import { GetStaticProps, NextPage } from 'next';
import { initializeApollo } from '../utils/apollo';
import { flatten } from '../utils/object';
import PageLayout, { MenuProps } from '../layouts/Page';
import { STORYBOOK_PAGE } from '../queries/storybook';
import StorybookView from '../views/StorybookView';
import { Error, sendError } from '../utils/error';

type StorybookProps = {
  menus: MenuProps;
  locale: string;
};

/**
 * Storybook
 */
const Storybook: NextPage<StorybookProps> = ({ menus, locale }) => {
  return (
    <PageLayout menus={menus} locale={locale} isHeaderTransparent={false}>
      <StorybookView />
    </PageLayout>
  );
};

/**
 * getStaticProps
 */
export const getStaticProps: GetStaticProps = async ({ locale }) => {
  try {
    const apolloClient = initializeApollo();
    const { data } = await apolloClient.query({
      query: STORYBOOK_PAGE,
      variables: {
        locale,
      },
    });

    const newData = flatten(data);

    return {
      props: {
        menus: {
          header: newData.header,
          technologies: newData.technologies,
          services: newData.services,
          footerPt: newData.footerPt,
          footerEn: newData.footerEn,
        },
      },
    };
  } catch (error) {
    sendError({ error: error as Error, message: 'Error on storybook page' });
    return {
      notFound: true,
    };
  }
};

export default Storybook;
